import {
  GET_CASE_CLAIMS_SUCCESS,
  GET_CASE_CLAIMS_FILTERS_SUCCESS,
} from '@actions/caseClaims';

const defaultState = {
  count: 0,
  data: [],
  debtors: [],
  statuses: [],
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case GET_CASE_CLAIMS_SUCCESS: {
      return {
        ...state,
        data: action.payload.results,
        count: action.payload.count,
      };
    }
    case GET_CASE_CLAIMS_FILTERS_SUCCESS: {
      return {
        ...state,
        debtors: action.payload.debtors,
        statuses: action.payload.statuses,
      };
    }
    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/caseClaims.js